var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.type == 'Quiz')?_c('module-quiz',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e(),(_vm.$route.params.type == 'Attendance')?_c('module-attendance',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e(),(_vm.$route.params.type == 'Assignment')?_c('module-assignment',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e(),(_vm.$route.params.type == 'Materi')?_c('module-material',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e(),(_vm.$route.params.type == 'Assessment')?_c('module-assessment',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e(),(_vm.$route.params.type == 'Synchronous')?_c('module-synchronous',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e(),(_vm.$route.params.type == 'GroupProject')?_c('module-group-project',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e(),(_vm.$route.params.type == 'IndividuProject')?_c('module-indie-project',{attrs:{"readonly":_vm.role != 'SUPERADMIN' &&
      !_vm.permissions.includes('LD') &&
      !_vm.permissions.includes('TEACHER')
        ? true
        : false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }